import styles from "./StockScore.module.scss";
import { FC, useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { withStockStamp } from "../stock-stamp-hoc/StockStampHOC";
import Meter from "../meter/Meter";

interface PropsTypes {
    mobile?: boolean;
    total: number;
}

const StockScore: FC<PropsTypes> = ({ total, mobile }) => {
    const isTablet = useMediaQuery("(min-width: 768px)");
    const isLaptop = useMediaQuery("(min-width: 1280)");
    const isDesktop = useMediaQuery("(min-width: 1920px)");
    const is4k = useMediaQuery("(min-width: 3840px)");

    const [size, setSize] = useState<string>();

    useEffect(() => {
        if (is4k) {
            setSize("150")
        } else if (isDesktop) {
            setSize("100")
        } else if (isTablet) {
            setSize("80")
        }
    }, [isTablet, isLaptop, isDesktop, is4k])

    return (
        <Box className={styles.StockScore}>
            <Box sx={{ marginTop: 1 }}>
                <Meter value={total} size={size} maxValue="100" />
            </Box>
        </Box>
    );
};

export default withStockStamp(StockScore, "total", { title: "Stock Score" });
